import { ModalDialog } from '@front10/base-elements';
import { useIsMobileView } from '@front10/utils';
import { OverlayContainer } from '@react-aria/overlays';
import { useOverlayTriggerState } from '@react-stately/overlays';
import * as React from 'react';
import Button from '../../../packages/base-elements/Button2';
import { CloseButton } from '../../../packages/base-elements/CloseButton';
import { EventDetailsCard } from '../../items/EventCard/EventDetailsCard';
import { useTranslation } from '@front10/utils';
import { ButtonLink } from '@front10/base-elements';

interface MoreInfoButtonProps {
  data: React.ComponentPropsWithoutRef<typeof EventDetailsCard>;
  notifyChange?: (value: boolean) => void;
  target?: string;
}

const moreInfo = 'More Info';

export function MoreInfoButton({ data, notifyChange = (e) => {}, target }: MoreInfoButtonProps) {
  const { moreInfoLinkInteractionType = 'popup' } = data;
  let state = useOverlayTriggerState({});
  const isMobile = useIsMobileView();
  const translate = useTranslation();

  React.useEffect(() => {
    notifyChange(state.isOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isOpen]);

  if (moreInfoLinkInteractionType === 'deeplink') {
    return (
      <ButtonLink variant="tertiary" href={data?.moreInfoLink} target={target}>
        {translate(`cmp-premium-experience-grid-moreInfo`, moreInfo)}
      </ButtonLink>
    );
  } else {
    return (
      <>
        <Button onPress={() => state.open()} variant="tertiary">
          {translate(`cmp-premium-experience-grid-moreInfo`, moreInfo)}
        </Button>
        {state.isOpen && (
          <OverlayContainer>
            <ModalDialog
              isOpen
              onClose={state.close}
              isDismissable
              size={isMobile ? 'fullscreen' : undefined}
            >
              <CloseButton variant="close" onPress={() => state.close()} />
              <EventDetailsCard sx={{ maxWidth: '604px' }} {...data} />
            </ModalDialog>
          </OverlayContainer>
        )}
      </>
    );
  }
}
